import { render } from "./EditDestination.vue?vue&type=template&id=2c7c41fe&scoped=true"
import script from "./EditDestination.vue?vue&type=script&lang=js"
export * from "./EditDestination.vue?vue&type=script&lang=js"

import "./EditDestination.vue?vue&type=style&index=0&id=2c7c41fe&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2c7c41fe"

export default script